import {axios as http} from "@/plugins/http"

export default class Api {
    static item(query) {
        let config = {
            params: query,
        }
        return http.get("/api/v1/shop/category/item", config);
    }

    static items(query) {
        let config = {
            params: query,
        }
        return http.get("/api/v1/shop/category/items", config);
    }

    static create(query) {
        return http.post("/api/v1/shop/category/create", query);
    }

    static update(query) {
        return http.post("/api/v1/shop/category/update", query);
    }

    static delete(query) {
        let config = {
            params: query,
        }
        return http.get("/api/v1/shop/category/delete", config);
    }
}
